// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"dd8ee15e","702":"1a830f92"}[chunkId] + ".chunk.js";
};